const images = {
  '03000000-1': {
    name: 'Agricultural, farming, fishing, forestry and related products',
    src: '03000000-1.png',
    url: 'https://www.bls.gov/opub/mlr/2014/images/fayer-homepage-image.jpg',
  },
  '09000000-3': {
    name: 'Petroleum products, fuel, electricity and other sources of energy',
    src: '09000000-3.png',
    url:
      'https://news.energysage.com/wp-content/uploads/2017/05/fossil-fuels-vs-solar-energy-624x468-1.jpg',
  },
  '14000000-1': {
    name: 'Mining, basic metals and related products',
    src: '14000000-1.png',
    url: 'https://www.south-africa-info.co.za/info/towns/551/images/bottom_images/9.jpg',
  },
  '15000000-8': {
    name: 'Food, beverages, tobacco and related products',
    src: '15000000-8.jpg',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/6/6d/Good_Food_Display_-_NCI_Visuals_Online.jpg',
  },
  '16000000-5': {
    name: 'Agricultural machinery',
    src: '16000000-5.png',
    url:
      'https://alansnowagriculturalengineers.co.uk/wp-content/uploads/2016/03/Kata-Mais-oben.jpg',
  },
  '18000000-9': {
    name: 'Clothing, footwear, luggage articles and accessories',
    src: '18000000-9.png',
    url:
      'https://underarmour.scene7.com/is/image/Underarmour/190430_SS19_Q2_ArmourBox_Site_PRM_W_Sportsstyle_Hand2?wid=1600&fmt=png',
  },
  '19000000-6': {
    name: 'Leather and textile fabrics, plastic and rubber materials',
    src: '19000000-6.png',
    url: 'https://nicolscales.com/wp-content/uploads/2016/07/towels-1511875_960_720.jpg',
  },
  '22000000-0': {
    name: 'Printed matter and related products',
    src: '22000000-0.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=MTk0NzU=',
  },
  '24000000-4': {
    name: 'Chemical products',
    src: '24000000-4.png',
    url: 'http://www.qfine-synthesis.com/wp-content/uploads/2018/10/FLASK-QFINE.jpg',
  },
  '30000000-9': {
    name:
      'Office and computing machinery, equipment and supplies except furniture and software packages',
    src: '30000000-9.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=MTUwOTg=',
  },
  '31000000-6': {
    name: 'Electrical machinery, apparatus, equipment and consumables; lighting',
    src: '31000000-6.png',
    url: 'https://upload.wikimedia.org/wikipedia/commons/7/71/Electrical_switchgear.JPG',
  },
  '32000000-3': {
    name: 'Radio, television, communication, telecommunication and related equipment',
    src: '32000000-3.png',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/1/1d/Kenwood_AT-230_antenna-tuner-inside.jpg',
  },
  '33000000-0': {
    name: 'Medical equipments, pharmaceuticals and personal care products',
    src: '33000000-0.png',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/b/b5/Assorted_pharmaceuticals_by_LadyofProcrastination.jpg',
  },
  '34000000-7': {
    name: 'Transport equipment and auxiliary products to transportation',
    src: '34000000-7.png',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/1/11/Freightliner_M2_106_6x4_2014_%2814240376744%29.jpg',
  },
  '35000000-4': {
    name: 'Security, fire-fighting, police and defence equipment',
    src: '35000000-4.png',
    url:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Teaneck_Fire_Department_Engine_2.jpg/468px-Teaneck_Fire_Department_Engine_2.jpg',
  },
  '37000000-8': {
    name:
      'Musical instruments, sport goods, games, toys, handicraft, art materials and accessories',
    src: '37000000-8.png',
    url: 'https://zen.collegevine.com/wp-content/uploads/2016/07/extracurricular.jpg',
  },
  '38000000-5': {
    name: 'Laboratory, optical and precision equipments (excl. glasses)',
    src: '38000000-5.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=NjI3OQ==',
  },
  '39000000-2': {
    name:
      'Furniture (incl. office furniture), furnishings, domestic appliances (excl. lighting) and cleaning products',
    src: '39000000-2.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=NTc0NA==',
  },
  '41000000-9': {
    name: 'Collected and purified water',
    src: '41000000-9.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=NzY1',
    children: [],
  },
  '42000000-6': {
    name: 'Industrial machinery',
    src: '42000000-6.png',
    url:
      'https://abas-erp.com/sites/default/files/styles/content-image-third/public/industrial-machinery-big-data.jpg?itok=gc424iF8',
    children: [],
  },
  '43000000-3': {
    name: 'Machinery for mining, quarrying, construction equipment',
    src: '43000000-3.png',
    url:
      'https://www.ft.com/__origami/service/image/v2/images/raw/https%3A%2F%2Fs3-ap-northeast-1.amazonaws.com%2Fpsh-ex-ftnikkei-3937bb4%2Fimages%2F8%2F7%2F5%2F9%2F12269578-4-eng-GB%2F0130N-Hitachi-Construction-Machinery.jpg?source=nar-cms',
    children: [],
  },
  '44000000-0': {
    name:
      'Construction structures and materials; auxiliary products to construction (except electric apparatus)',
    src: '44000000-0.png',
    url:
      'https://buildingmaterials.com.my/wp-content/uploads/2019/03/15-sustainable-green-materials-recycle-building-materials.jpg',
    children: [],
  },
  '45000000-7': {
    name: 'Construction work',
    src: '45000000-7.png',
    url:
      'https://www.constructionlawyersydney.com/wp-content/uploads/2017/02/front-page-contractual-advice-cti-lawyers.jpg',
  },
  '48000000-8': {
    name: 'Software package and information systems',
    src: '48000000-8.png',
    url: 'https://upload.wikimedia.org/wikipedia/en/1/15/IDRISI_GIS_Seasonal_Trends.jpg',
  },
  '50000000-5': {
    name: 'Repair and maintenance services',
    src: '50000000-5.png',
    url: 'http://www.fastmaintenance.ae/wp-content/uploads/2016/04/Maintenance_Services_Dubai.jpg',
  },
  '51000000-9': {
    name: 'Installation services (except software)',
    src: '51000000-9.png',
    url:
      'https://img3.exportersindia.com/product_images/bc-full/2018/9/5719467/cctv-camera-installation-services-1536665688-4288806.jpeg',
  },
  '55000000-0': {
    name: 'Hotel, restaurant and retail trade services',
    src: '55000000-0.png',
    url: 'https://www.tendersontime.com /get-blog-image.php?id=MjU2NDg=',
  },
  '60000000-8': {
    name: 'Transport services (excl. Waste transport)',
    src: '60000000-8.png',
    url: 'https://blog.ipleaders.in/wp-content/uploads/2017/04/BV-Acharya-7.jpg',
  },
  '63000000-9': {
    name: 'Supporting and auxiliary transport services; travel agencies services',
    src: '63000000-9.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=NjYzNQ==',
  },
  '64000000-6': {
    name: 'Postal and telecommunications services',
    src: '64000000-6.png',
    url: 'https://news.sap.com/africa/files/2018/03/post.jpg',
  },
  '66000000-0': {
    name: 'Financial and insurance services',
    src: '66000000-0.png',
    url: 'http://www.inspiredinfotech.com/wp-content/uploads/2019/05/banking-banner.jpg',
  },
  '70000000-1': {
    name: 'Real estate services',
    src: '70000000-1.png',
    url: 'http://solar-area-lighting.com/wp-content/uploads/2017/05/Purchasing-a-Home.jpg',
  },
  '71000000-8': {
    name: 'Architectural, construction, engineering and inspection services',
    src: '71000000-8.png',
    url: 'https://ak6.picdn.net/shutterstock/videos/16966336/thumb/1.jpg',
  },
  '72000000-5': {
    name: 'IT services: consulting, software development, Internet and support',
    src: '72000000-5.png',
    url: 'https://www.tendersontime.com/get-blog-image.php?id=MjQ4Ng==',
  },
  '73000000-2': {
    name: 'Research and development services and related consultancy services',
    src: '73000000-2.png',
    url:
      'https://www.globalspec.com/ImageRepository/LearnMore/20133/researchanddevelopment842b309416084facb23fd371f43a75e0.png',
  },
  '76000000-3': {
    name: 'Services related to the oil and gas industry',
    src: '76000000-3.png',
    url:
      'https://i.cbc.ca/1.5031351.1550963845!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_780/drilling-rig-training-20170129.jpg',
  },
  '77000000-0': {
    name: 'Agricultural, forestry, horticultural, aquacultural and apicultural services',
    src: '77000000-0.png',
    url:
      'https://extension.wvu.edu/files/bc757f9a-e591-49a4-abfb-58f0d508fb65/404x269?cb=1522855347',
  },
  '79000000-4': {
    name: 'Business services: law, marketing, consulting, recruitment, printing and security',
    src: '79000000-4.png',
    url:
      'https://www.fticonsulting.com/~/media/Images/shared-content/homepages/featured-content/homepg_our-impact.jpg?h=375&la=en&w=600&hash=55EECB6FA83552C6D695C1925B477E68EF875AC3',
  },
  '80000000-4': {
    name: 'Education and training services',
    src: '80000000-4.png',
    url: 'https://www.nibaara.com/wp-content/uploads/2018/02/corporate-training.jpg',
  },
  '85000000-9': {
    name: 'Health and social work services',
    src: '85000000-9.png',
    url: 'https://www.mountsinai.org/files/MSHealth/Assets/MSH/MSHS-SocialWork-2col-640x360-2.jpg',
  },
  '90000000-7': {
    name: 'Sewage, refuse, cleaning and environmental services',
    src: '90000000-7.png',
    url:
      'https://www.csg.co.uk/wp-content/uploads/2018/02/Website-Images-resized-min-1-2000x831.jpg',
  },
  '92000000-1': {
    name: 'Recreational, cultural and sporting services',
    src: '92000000-1.png',
    url:
      'https://english.leipzig.de/fileadmin/_processed_/9/c/csm_HCL_Sebastian_Brauner_Totale_ARENA_klein_e5effcf360.jpg',
  },
  '98000000-3': {
    name: 'Other community, social and personal services',
    src: '98000000-3.png',
    url:
      'https://www.odysseyhouse.com.au/wordpress/wp-content/uploads/2018/10/friends-of-all-ages-picture-id897266260-3.jpg',
  },
}

export default images
